export const daysOfWeekMapHorarios = {
  0: 'horariosDomingos',
  1: 'horariosLunes',
  2: 'horariosMartes',
  3: 'horariosMiercoles',
  4: 'horariosJueves',
  5: 'horariosViernes',
  6: 'horariosSabados'
};

export const daysOfWeekMapHabilitados = {
  0: 'habilitadoDomingos',
  1: 'habilitadoLunes',
  2: 'habilitadoMartes',
  3: 'habilitadoMiercoles',
  4: 'habilitadoJueves',
  5: 'habilitadoViernes',
  6: 'habilitadoSabados'
};

export const minutos = [
  {
    valor: '00',
    solapados: ['00', '15']
  }, {
    valor: '30',
    solapados: ['30', '45']
  }
];

export const horas = ['06',
'07',
'08',
'09',
'10',
'11',
'12',
'13',
'14',
'15',
'16',
'17',
'18',
'19',
'20',
'21',
'22',
'23'
];

export const horarios = [
  {
    rango: 'Mañana',
    horas: ['06',
  '07',
  '08',
  '09',
  '10',
  '11']
  }, {
    rango: 'Tarde',
    horas: ['12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18']
  }, {
    rango: 'Noche',
    horas: ['19',
  '20',
  '21',
  '22',
  '23']
  }];


// WEBPACK FOOTER //
// ./src/core/util/constants.js